import * as ActionTypes from '../actions/index';



const defaultState = {
    questionAnswerRevisions: {},
    fetchingQuestionAnswerRevisions: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS:
            return  {
                ...state,
                fetchingQuestionAnswerRevisions: true
            };
        case ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS_SUCCESS:
            return {
                ...state,
                fetchingQuestionAnswerRevisions: false,
                questionAnswerRevisions: action.payload.body
            };
        case ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS_FAILED:
            return {
                ...state,
                fetchingQuestionAnswerRevisions: false
            };
        case ActionTypes.LOGOUT:
            return defaultState;
        default :
            return state
    }
}